<template>
    <div class="listado" :id="`listado_${entidad}`" v-loading="loading">

        <!-- Hay una configuracion que mostrar -->
        <template v-if="listado && !error">
            
            <!-- Listado -->
            <ul>
                <li class="filtro">
                    <el-checkbox :value="allCheckList" @change="setAllCheckList()" style="margin-right: 15px; flex-shrink: 0">Seleccionar todos</el-checkbox>
                    <el-input placeholder="Buscar..." size="mini" v-model="search" class="input-with-select"/>
                </li>
                <li 
                class="item"
                v-for="(item,i) in filterBySearch"
                :key="i"
                :class="[{selected: selected && selected == item}]"
                @click="selectedItem(item)">
                    <el-checkbox :value="checkList.map(f => f.id).includes(item.id)" @change="addCheckList(item)" style="margin-right: 15px; flex-shrink: 0"/>
                    <div class="item-content">
                        <p>{{item.title}}</p>
                        <p class="description">{{item.description}}</p>
                    </div>
                    <i class="el-icon-arrow-right"></i>
                </li>
                <li class="noresult" v-if="!filterBySearch.length">
                    <div class="empty">
                        <img src="../../assets/NoSearchResult.png">
                        <p>No hemos encontrado nada</p>
                    </div>
                </li>
            </ul>

            <!-- Firmar seleccionados -->
            <div class="firmar" v-if="(allCheckList && checkList.length) || checkList.length > 1">
                <el-input placeholder="Contraseña" v-model="password" show-password>
                    <el-button slot="append" type="default" @click="firmar()">Firmar seleccionados</el-button>
                </el-input>
            </div>

        </template>

        <!-- Errores -->
        <template v-else-if="error">
            <el-row style="padding: 10px; min-height: 150px">
                <el-col :span="24">
                    <div class="empty">
                        <img src="../../assets/Error.png">
                        <p>Ha ocurrido un error, vuelve a recargar mas tarde</p>
                    </div>
                </el-col>
            </el-row>
        </template>

        <!-- Requiere una recarga para obener datos -->
        <template v-else>
            <div class="empty">
                <img src="../../assets/NoSearchResult.png">
                <p>Recarga para obtener datos</p>
            </div>
        </template>
        
    </div>
</template>

<script>

    import {
		postSelectorEntidad,
        getSelectorEstructura,
        getSelectorDatos,

        getRelacionEstructura,
        getRelacionDatos,

        getBuscadorEstructura,
        getBuscadorDatos,

        setDefaultsHeaders,

        getTableInforme,
        getUrl,

        getListaDocumentosPdf,

        postActionData 
    } from '@/helpers/api'

    import { mapMutations } from 'vuex'

	export default {
        name: 'Listado',
        props: {
            id: String,
            ficha: Object,
            entidad: String,
            porlet: Object,
            currentAction: Object,
            reload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            autoReload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            visibleReload: {
                type: Boolean,
                required: false,
                default: () => false
            }
        },
		data () {
			return {
                search: '',
                listado: null,
                loading: false,
                error: null,
                selected: null,
                checkList: [],
                allCheckList: false,
                password: '',

                // Comparador
                filters_operator: [{
                        id: 1,
                        label: 'Igual',
                        operator: '='
                    }, {
                        id: 2,
                        label: 'Mayor/igual',
                        operator: '>='
                    }, {
                        id: 3,
                        label: 'Menor/igual',
                        operator: '<='
                    }, {
                        id: 4,
                        label: 'Mayor',
                        operator: '>'
                    }, {
                        id: 5,
                        label: 'Menor',
                        operator: '<'
                    }, {
                        id: 6,
                        label: 'Contiene',
                        operator: '@'
                    }, {
                        id: 7,
                        label: 'Empieza',
                        operator: '['
                    }, {
                        id: 8,
                        label: 'Termina',
                        operator: ']'
                    }, /*{
                        id: 9,
                        label: 'Entre',
                        operator: '<>'
                    },*/ {
                        id: 10,
                        label: 'Diferente',
                        operator: '!='
                    }, {
                        id: 11,
                        label: 'No contiene',
                        operator: '!@'
                    } /*,{
                        id: 12,
                        label: 'Lista',
                        operator: '≡'
                    }*/, {
                        id: 13,
                        label: 'Vacio',
                        operator: '□'
                    }, {
                        id: 14,
                        label: 'No vacio',
                        operator: '▦'
                    }
                ]
            }
        },
        computed:{
            filterBySearch() {
                return this.listado.filter(f => f.title.includes(this.search) || f.description.includes(this.search))
            }
        },
        mounted() {

            this.getData()

            this.$emit('created')
        },
        methods: {
            async getData() {

                this.selected = null
                this.checkList = []
                this.allCheckList = false
                this.error = false
                this.search = ''
                this.allCheckList = false
                this.listado = null

                if (this.loading) return
                
                this.error = false
                this.table = null

                this.loading = true

                try {
                              
                    var formData = new FormData();

                    formData.append('tipo', 'ptes');
                    
                    let resp = null

                    let resp_docs = await getListaDocumentosPdf(formData)

                    resp = resp_docs.data
                    
                    this.listado = resp.data.datos

                } catch(err) {
                    this.error = true
                }

                this.loading = false
            },

            selectedItem(item) {
                this.selected = (this.selected && this.selected.id == item.id) ? null : item
                if (!this.selected) return
                
                if (this.$referencias.VisorPDF) {

                    // Cargar ID en Visor
                    this.$referencias.VisorPDF.getData(this.selected.id)

                    // Scroll al Visor
                    let coords = this.$referencias.VisorPDF.$el.getBoundingClientRect()
                    let section_center = document.querySelector('.section-center')
                    let section_center_top = section_center.getBoundingClientRect().top
                    let offset = 135
                    section_center.scrollTop = (section_center_top + coords.top) - offset
                }
            },

            addCheckList(item) {
                
                if(this.allCheckList) {
                    this.checkList = []
                    this.allCheckList = false
                }

                let indexExist = this.checkList.findIndex(f => f.id === item.id)

                if (!!~indexExist) {
                    this.checkList.splice(indexExist, 1)
                } else {
                    this.checkList.push(item)
                }
            },

            // Seleccionar toda la lista
            setAllCheckList() {
                console.log('setAllCheckList')
                this.checkList = []

                if(!this.allCheckList) {
                    
                    this.listado.forEach(item => this.checkList.push(item))
                    
                    this.allCheckList = true
                } else {
                    this.allCheckList = false
                }
            },

            refresh() {
                this.getData()
            },

            // Firmar documentos
            async firmar() {

                this.loading = true

                try {

                    let formData = new FormData()
                    
                    formData.append('password', this.password || '')
                    formData.append('selected', this.checkList.map(m => m.id))

                    let resp = await postActionData('firmar.php', formData, 'post')
                    console.log('firmar: ',resp)

                    this.password = ''

                    if (resp && resp.data && resp.data.recargarComponentes && resp.data.recargarComponentes.length) {
                        resp.data.recargarComponentes.forEach(comp => {
                            this.$referencias[comp].refresh()
                        })
                    }

                    if (resp && resp.data && resp.data.mensajes && resp.data.mensajes.length) {
                        resp.data.mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })
                    }

                    this.file = ''

                } catch (e) {

                    console.log('error listado: ',e)
                    
                    if (e && e.response && e.response.data && e.response.data.mensajes) {

                        e.response.data.mensajes.filter(f => f['message-type'] !== 'Alert').forEach(mensaje => {
                            setTimeout(() => {
                                this.$notify({
                                    title: mensaje.title,
                                    message: mensaje.message,
                                    type: mensaje.type,
                                    position: mensaje.position
                                });
                            }, 5)
                        })

                    } else {

                        this.$notify.error({
                            title: 'Error',
                            message: 'Ha ocurrido un error'
                        });
                    }
                }

                this.loading = false
            }
        }   
	}
</script>

<style lang="scss">
.listado {
    flex-grow: 1;
    display: flex;
    flex-flow: column;
    overflow: hidden;

    ul {
        padding: 0px;
        margin: 0px;
        list-style: none;
        flex-grow: 1;
        display: flex;
        flex-flow: column;
        overflow-y: scroll;
        li {
            border-bottom: 1px solid #EBEEF5;
            padding: 0.6rem 0.9rem;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            align-items: center;
            flex-shrink: 0;
            .item-content {
                flex-grow: 1;
                p {
                    margin: 0px;
                    text-overflow: ellipsis;
                    word-break: break-word;
                    white-space: nowrap;
                    overflow: hidden;
                    &.description {
                        font-size: 0.7rem;
                    }
                }
            }
            i {
                display: none;
            }
            &.noresult {
                justify-content: center!important;
                border-bottom: 0px;
                flex-grow: 1;
            }
            &.item:hover {
                background-color: #f2f6fc8c;
            }
            &.selected {
                background-color: #f2f6fc;
                i {
                    display: block;
                }
            }
            &.filtro {
                position: sticky;
                top: 0;
                background-color: white;
                z-index: 9;
            }
        }
    }

    .firmar {
        padding: 10px 15px 6px 15px;
        border-top: 1px solid #ebeef5;
        flex-shrink: 0;
    }
}
</style>